import cn from 'classnames';
import { Header } from '@widgets/header';
import { usePlatformSettings } from '@shared/hooks';
import { Footer } from './footer/index.tsx';
import * as st from './styles.module.scss';

export const Main: React.FC = () => {
  const settings = usePlatformSettings();
  return (
    <>
      <Header MCenter={<>Главная страница</>} />
      <main className={cn(st.main, !settings.iframe_url && st.withoutIframe)}>
        {settings?.iframe_url && (
          <iframe id="mainPageIframe" className={st.frame} title="home" src={settings.iframe_url} />
        )}
        <Footer />
      </main>
    </>
  );
};
